import StampModificationPage from './StampModificationPage';

export default StampModificationPage;
